<template>
  <div class="d-flex flex-wrap align-center">
    <v-text-field
      :label="label"
      :placeholder="placeholder"
      :solo="solo"
      :clearable="clearable"
      :solo-inverted="soloInverted"
      :color="color"
      :filled="filled"
      :disabled="disabled"
      :loading="loading"
      :style="searchBarStyle"
      :classes="classes['searchBar']"
      class="expand-on-focus"
      :dense="dense"
      hide-details="auto"
      v-model="search"
      @focus="expand"
      @blur="collapse"
      @keydown="keydown"
    ></v-text-field>
    <slot name="search-button" v-bind:search-text="search">
      <v-btn
        :loading="loading"
        class="ml-2"
        :style="localStyle['button']"
        @mousedown="clickOnButton"
        icon
      >
        <v-icon>
          {{searchIcon}}
        </v-icon>
      </v-btn>
    </slot>
  </div>
</template>

<script>
import emittable from '../../mixins/emittable'

import {
  VTextField,
  VBtn,
  VIcon
} from 'vuetify/lib'

export default {
  name: "SearchWithButton",
  components: {
    VTextField,
    VBtn,
    VIcon
  },
  mixins: [emittable],
  data: function() {
    let sbs;
    if(!this.styles.searchBar) {
      sbs = {}
    } else {
      sbs = { ...this.styles.searchBar }
    }

    if(!sbs.width) {
      sbs.width = '300px'
    }

    return {
      search: this.searchText,
      localStyle: { ...this.styles },
      searchBarStyle: sbs
    }
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Search ...'
    },
    solo: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: 'primary'
    },
    filled: {
      type: Boolean,
      default: true
    },
    iconAppend: {
      type: Boolean,
      default: false
    },
    searchIcon: {
      type: String,
      default: 'mdi-search-web'
    },
    soloInverted: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    searchOnEnter: {
      type: Boolean,
      default: true
    },
    searchOnIconClick: {
      type: Boolean,
      default: true
    },
    expandOnFocus: {
      type: Boolean,
      default: false
    },
    searchText: {
      type: String,
      default: undefined
    },
    styles: {
      type: Object,
      default: function() {
        return {
          'searchBar': {},
          'button': {}
        }
      }
    },
    classes: {
      type: Object,
      default: function() {
        return {
          'searchBar': {},
          'button': {}
        }
      }
    }
  },
  methods: {
    keydown(event) {
      if(event.keyCode == 13 && this.searchOnEnter) {
        this.emit('search', this.search)
      } else {
        this.emit('key-down')
      }
    },
    clickOnButton() {
      this.emit('search', this.search)
    },
    expand() {
      let width = this.searchBarStyle['width']
      if(!width) {
        width = "300px"
      }

      let finalWidth;
      if(this.expandOnFocus) {
        if(width.includes('px')) {
          finalWidth = parseInt(width.substring(0, width.length - 2)) + 100
          finalWidth = finalWidth + 'px'
        }
      }

      this.searchBarStyle['transition'] = "width 0.3s"
      this.searchBarStyle['width'] = finalWidth
    },
    collapse() {
      let width = this.searchBarStyle['width']
      if(!width) {
        width = "300px"
      }

      let finalWidth;
      if(this.expandOnFocus) {
        if(width.includes('px')) {
          finalWidth = parseInt(width.substring(0, width.length - 2)) - 100
          finalWidth = finalWidth + 'px'
        }
      }

      this.searchBarStyle['transition'] = "width 0.3s"
      this.searchBarStyle['width'] = finalWidth
    }
  },
  watch: {
    search(newVal) {
      this.emit('update:search-text', newVal) 
    }
  }
}
</script>

<style scoped>

</style>